import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaCommentDots } from "react-icons/fa";
import { apihubPost } from "../../api/apihub";
import { businessPath } from "../../config/businessMenu";
import { useProjectPhone } from "../../hooks/useProjectPhone";

const TYPES = ["TEXT", "IMAGE", "VIDEO", "DOCUMENT", "AUDIO"];

const CreateCannedMessage = () => {
  const { projectId } = useProjectPhone();
  const [name, setName] = useState("");
  const [type, setType] = useState("TEXT");
  const [text, setText] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!projectId) return;
    setSubmitting(true);
    setError("");
    try {
      const payload = {
        name: name.trim(),
        type: type.toLowerCase(),
        text,
        mediaUrl: type === "TEXT" ? "" : mediaUrl,
        fileName: "",
        project_id: projectId,
      };
      await apihubPost(
        "/getInteractedCustomerDetail/createcannedmessage",
        payload,
      );
      setSuccess(true);
      setName("");
      setText("");
      setMediaUrl("");
      setType("TEXT");
    } catch (err) {
      setError(err.message || "Failed to create canned message");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="biz-panel-page">
      <div className="biz-panel-header">
        <h1>
          <FaCommentDots />
          New Canned Message
        </h1>
        <Link
          to={businessPath(projectId, "fetchallcannedmessage")}
          className="biz-btn-outline"
        >
          <FaArrowLeft />
          Go Back
        </Link>
      </div>

      <form className="biz-canned-form" onSubmit={onSubmit}>
        {success && (
          <p className="biz-dialogflow-success">
            Canned message saved successfully.
          </p>
        )}
        {error && <p className="biz-panel-error">{error}</p>}

        <label>
          Name
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>

        <label>
          Type
          <select value={type} onChange={(e) => setType(e.target.value)}>
            {TYPES.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </label>

        <label>
          Text
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={4}
          />
        </label>

        {type !== "TEXT" && (
          <label>
            Media URL
            <input
              type="url"
              value={mediaUrl}
              onChange={(e) => setMediaUrl(e.target.value)}
              placeholder="https://..."
            />
          </label>
        )}

        <button type="submit" className="biz-btn-primary" disabled={submitting}>
          {submitting ? "Saving…" : "Save Canned Message"}
        </button>
      </form>
    </div>
  );
};

export default CreateCannedMessage;
